import { IComponentOptions } from "angular";
import { SelectRecordModalComponentController } from "./controller";

export const selectRecordModalComponentOptions: IComponentOptions = {
  controller: SelectRecordModalComponentController,
  controllerAs: "modalController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    modalInstance: "=",
    resolve: "=",
  },
};
